import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"

import { cn } from "../lib/cn"

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-md border px-2 py-1.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring aria-invalid:border-destructive [&>svg]:pointer-events-none [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-primary underline-offset-4 [a&]:hover:underline",
      },
      tom: {
        verde: "rounded-sm border-transparent bg-status-sucesso text-sobre-status-sucesso [&>svg]:text-sobre-status-sucesso",
        ambar: "rounded-sm border-transparent bg-status-atencao text-sobre-status-atencao [&>svg]:text-sobre-status-atencao", // anti-ia-ok: nome de classe Tailwind ("atencao" no token, não prosa — o `[&>svg]:` quebra a heurística de lista de classe)
        vermelho: "rounded-sm border-transparent bg-status-erro text-sobre-status-erro [&>svg]:text-sobre-status-erro",
        cinza: "rounded-sm border-transparent bg-muted-foreground text-sobre-tom [&>svg]:text-sobre-tom",
      },
    },
    defaultVariants: {
      variant: "outline",
    },
  },
)

function Badge({
  className,
  variant,
  tom,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span"

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      data-tom={tom}
      className={cn(badgeVariants({ variant, tom }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
